<template>
  <div class="social-links">
          <a v-for="social in socials" 
             :key="social.id" 
             :href="social.link" 
             target="_blank" 
             onClick="event.target.blur()" >
            <svg :aria-labelledby="`#${social.name}-logo`" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 225">
              <title :id="`${social.name}-logo`">{{social.titleText}}</title>
              <g v-html="social.logo"> </g>
            </svg>
          </a>
        </div>
</template>

<script>

export default {
  name: "socialLinks",
  data() {
    return {
      socials: [
        {
            name: 'linkedin',
            link: 'https://www.linkedin.com/in/caitlinmgleason/',
            titleText: 'Follow Caitlin on LinkedIn',
            logo: '<path d="M225,44.36V180.64c0,2.37-.42,4.71-.99,7.01,0,0,0,.02,0,.03-4.16,17.15-14.47,28.82-31.06,34.86-1.23,.45-2.48,.84-3.73,1.21-2.78,.83-5.67,1.25-8.57,1.25H44.37c-2.37,0-4.71-.42-7.02-.99,0,0-.02,0-.03,0-17.15-4.15-28.81-14.47-34.86-31.06-.45-1.23-.84-2.48-1.22-3.73C.42,186.43,0,183.54,0,180.64V44.35c0-2.37,.42-4.71,.99-7.01,0,0,0-.02,0-.03C5.15,20.17,15.46,8.51,32.06,2.46c1.23-.45,2.48-.84,3.73-1.22C38.57,.42,41.46,0,44.36,0c45.42,0,90.85,0,136.27,0,2.38,0,4.72,.42,7.02,.99,0,0,.02,0,.03,0,17.15,4.15,28.82,14.46,34.86,31.06,.45,1.23,.84,2.48,1.21,3.73,.83,2.78,1.25,5.67,1.25,8.57ZM121.97,177.88c0-17.74-.36-34.9,.21-52.04,.17-5.2,2.07-10.8,4.67-15.37,3.47-6.09,9.75-8.34,16.81-7.4,6.79,.91,11.25,5.07,13.43,11.26,1.3,3.69,1.94,7.78,1.99,11.7,.22,15.49,.09,30.99,.09,46.49,0,1.76,0,3.52,0,5.26h28.49c0-6.94,.07-13.57-.01-20.2-.23-17.32,.34-34.7-1.03-51.93-1.52-19.1-16.72-31.54-35.45-30.54-11.61,.62-21.53,5.07-29.32,16.05v-15.82h-27.7v102.53h27.8Zm-47.31,.03V75.36h-27.41v102.55h27.41Zm2.53-131.59c-.1-8.93-7.31-16.2-16.14-16.28-9.08-.08-16.32,7.28-16.3,16.56,.02,9.33,7.13,16.47,16.34,16.4,9.11-.07,16.21-7.42,16.1-16.69Z"/>'
        },
        {
            name: 'github',
            link: 'https://github.com/caitlinmgleason/portfolio',
            titleText: `See the sourcecode for Caitlin's portfolio site on Github`,
            logo: '<path d="M222.54,32.06c-6.04-16.6-17.7-26.91-34.86-31.06l-1.17-.29c-1.92-.47-3.9-.71-5.87-.71H44.36c-2.9,0-5.79,.42-8.57,1.25-1.26,.38-2.5,.77-3.73,1.22C15.46,8.51,5.15,20.17,.99,37.32c0,0,0,.02,0,.03-.57,2.3-.99,4.64-.99,7.01V180.64c0,2.9,.42,5.79,1.25,8.57,.38,1.25,.77,2.5,1.22,3.73,6.04,16.59,17.7,26.91,34.86,31.06,0,0,.02,0,.03,0,2.31,.57,4.65,.99,7.02,.99h42.12c3.29-1.33,4.81-5.61,1.79-10.2-2.53-3.86-2.05-8.88,.72-12.57,1.01-1.35,.81-2.21,.74-3.32-1.78,.25-3.44,.5-5.11,.71-6.08,.77-12.15,.86-18.11-.81-6.52-1.84-11.51-5.58-14.13-11.99-1.68-4.1-3.83-7.91-6.4-11.49-1.78-2.48-3.8-4.7-6.58-6.19-1.29-.69-2.46-1.76-3.44-2.86-1.64-1.85-1.03-3.33,1.42-3.76,4.45-.78,8.5,.2,12.2,2.77,3.65,2.54,6.36,5.91,8.72,9.63,3.31,5.19,7.71,9,13.84,10.47,5.94,1.42,11.63,.37,17.2-1.84,.81-.32,1.07-.8,1.2-1.6,.48-3.13,1.37-6.17,3.03-8.88,1.07-1.76,2.39-3.37,3.6-5.06-.89-.13-1.87-.27-2.85-.41-6.58-.94-13.05-2.29-19.23-4.83-12.93-5.3-21.59-14.52-25.74-27.92-2.44-7.9-3.23-16-3.02-24.21,.26-10.33,3.77-19.48,10.5-27.34,.75-.88,.84-1.53,.5-2.59-2.97-9.29-2.07-18.43,1.22-27.46,.32-.88,.79-1.16,1.67-1.21,4.04-.23,7.84,.79,11.58,2.13,6,2.16,11.5,5.28,16.81,8.77,.94,.61,1.74,.76,2.83,.47,7.67-2.08,15.5-3.15,23.44-3.39,10.32-.31,20.48,.83,30.45,3.52,.59,.16,1.23,.05,1.73-.29,4.52-3.08,9.23-5.81,14.27-7.96,3.96-1.69,8.02-2.97,12.35-3.32,3.26-.27,3.54-.16,4.55,2.9,2.89,8.8,3.45,17.65,.35,26.52-.24,.68,.09,1.01,.46,1.43,6.31,7.25,9.95,15.67,10.7,25.25,.65,8.28-.07,16.48-2.21,24.52-3.36,12.66-10.59,22.3-22.4,28.29-6.47,3.28-13.4,5.08-20.51,6.26-1.93,.32-3.86,.58-5.82,.86,1.02,1.27,2.04,2.38,2.87,3.62,2.82,4.19,4.09,8.93,4.3,13.89,.22,5.27,.14,10.56,.14,15.83,0,6.16-.09,12.32-.08,18.48,0,2.61,1.22,4.31,3.51,5.17h31.11c2.9,0,5.79-.42,8.57-1.25,1.25-.38,2.5-.77,3.73-1.21,16.6-6.04,26.91-17.71,31.07-34.86v-.03c.55-2.21,.99-5.89,.99-8.17V44.36c0-2.9-.42-5.79-1.25-8.57-.38-1.25-.77-2.5-1.21-3.73Z"/>'
        },
        {
            name: 'instagram',
            link: 'https://www.instagram.com/html_chan/',
            titleText: `See Caitlin's Instagram`,
            logo: '<path d="M222.54,32.06c-6.04-16.6-17.7-26.91-34.86-31.06,0,0-.02,0-.03,0-2.31-.57-4.65-.99-7.02-.99H44.36c-2.9,0-5.79,.42-8.57,1.25-1.26,.38-2.5,.77-3.73,1.22C15.46,8.51,5.15,20.17,.99,37.32c0,0,0,.02,0,.03-.57,2.3-.99,4.64-.99,7.01V180.64c0,2.9,.42,5.79,1.25,8.57,.38,1.25,.77,2.5,1.22,3.73,6.04,16.59,17.7,26.91,34.86,31.06,0,0,.02,0,.03,0,2.31,.57,4.65,.99,7.02,.99H180.64c2.9,0,5.79-.42,8.57-1.25,1.25-.38,2.5-.77,3.73-1.21,16.6-6.04,26.91-17.71,31.07-34.86,0,0,0-.02,0-.03,.57-2.3,.99-4.64,.99-7.01V44.36c0-2.9-.42-5.79-1.25-8.57-.38-1.25-.77-2.5-1.21-3.73Zm-51.47,35.51c-7.5,.11-13.53-5.76-13.68-13.34-.15-7.32,6.09-13.58,13.51-13.55,7.18,.03,13.3,6.01,13.42,13.1,.12,7.48-5.83,13.68-13.25,13.79Zm-58.76,98.95c-29.35-.05-53.71-24.24-53.85-53.47-.13-29.95,24.19-54.45,54.01-54.41,29.59,.04,53.8,24.31,53.86,54.01,.06,29.44-24.49,53.92-54.03,53.87Z"/><path d="M112.55,148.49c19.86-.16,35.99-16.53,35.77-36.34-.21-19.27-16.84-35.62-36.14-35.52-19.39,.1-35.75,16.51-35.73,35.83,.02,19.87,16.35,36.18,36.09,36.02Z"/>'
        }
      ]
    };
  },
}
</script>

<style lang="less">
.social-links {
      display: flex;
      a {
        display: block;
        &:hover svg, &:focus svg { 
          background: #9fffee; 
          box-shadow: #9fffee 0px 0px 0px 5px;
        }
        &:focus svg {
          box-shadow: #9fffee 0px 0px 30px 5px, 
                      #9fffee 0px 0px 0px 4px; 
        }
      }
      svg {
        pointer-events: none;
        border-radius: 19%;
        width: 30px;
        margin: 10px;
        @media (min-width: 400px) {
          width: 40px;
        }
        @media (min-width: 800px) {
          width: 60px;
          margin: 15px;
        }
        path{ fill: #2f2068; }
      }
    }
</style>